class ExternalLinks {
	static TIMEOUT_MS = 2000
	static SELECTOR_BLANK_LINKS = 'a[target="_blank"]'
	static ATTR_TITLE = 'title'
	static PROP_NEW_WINDOW_TEXT = 'opens a new window'

	constructor() {
		setTimeout( () => {
			this.init()
		}, ExternalLinks.TIMEOUT_MS )
	}

	init() {
		const blankLinks = document.querySelectorAll( ExternalLinks.SELECTOR_BLANK_LINKS )

		blankLinks.forEach( ( link ) => {
			const oldTitle = link.getAttribute( ExternalLinks.ATTR_TITLE )
			if ( oldTitle && oldTitle.trim() !== '' ) {
				link.setAttribute( ExternalLinks.ATTR_TITLE, `${ oldTitle } - ${ ExternalLinks.PROP_NEW_WINDOW_TEXT }` )
			} else {
				link.setAttribute( ExternalLinks.ATTR_TITLE, ExternalLinks.PROP_NEW_WINDOW_TEXT )
			}
		} )
	}
}

export default function init() {
	new ExternalLinks()
}